// Importing specific icons from react-icons/fa
import {
  FaUser,     // Substitui FaUsers (users com singular)
  FaPlus,     // Substitui FaUserPlus
  FaUser as FaUserAlt,  // FaUser já está disponível
  FaUserTie,  // Vamos manter para ver se funciona
  FaQuestionCircle, // Substitui FaQuestion
  FaCheckDouble,  // Vamos manter para ver se funciona
} from "react-icons/fa";

// Importing specific icons from react-icons/md
import {
  MdWork,         // Vamos manter para ver se funciona
  MdBusiness,     // Substitui MdBusinessCenter
  MdSchool,       // Vamos manter para ver se funciona
  MdAssignment,   // Substitui MdTask
  MdQuestionAnswer, // Vamos manter o que existe
  MdList,         // Substitui MdListAlt
  MdTimer,        // Vamos manter para ver se funciona
  MdDashboard,    // Vamos manter para ver se funciona
  MdLabel,        // Vamos manter para ver se funciona
} from "react-icons/md";

import { IconType } from "react-icons";

// Restricted icon mapping
const iconMap: { [key: string]: IconType } = {
  FaUsers: FaUser,
  FaUserPlus: FaPlus,
  FaUserAlt,
  FaUserTie,
  FaQuestion: FaQuestionCircle,
  FaCheckDouble,
  MdWork,
  MdBusinessCenter: MdBusiness,
  MdSchool,
  MdTask: MdAssignment,
  MdOutlineQuestionAnswer: MdQuestionAnswer,
  MdListAlt: MdList,
  MdTimer,
  MdList,
  MdQuestionAnswer,
  MdDashboard,
  MdLabel,
};

// Function to get the icon based on the name
export const getIcon = (iconName: string): IconType | null => {
  return iconMap[iconName] || null;
};
